import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class CrudFb60Service {
  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  obtenerProductos(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath + 'claveSat/obtener', options);
  }

  guardarCargaProductos(archivoexcel): Observable<any> {
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
    //  params: new HttpParams()
    //  .set('archivoexcel', archivoexcel)
    };
    return this.http.post(this.basePath + 'claveSat/carga-productos', archivoexcel, options);
  }

  /*  Crear o actualizar productos */
  postCargaProductos(producto): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('claveSat', producto)
    };
    return this.http.post(this.basePath + 'claveSat/crear-actualizar', '', options);
  }

  eliminarProducto(producto): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('productoSat', producto)
    };
    return this.http.delete(this.basePath + 'claveSat/eliminar', options);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/crud-fb60/crud-fb60.service.ts